<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Title</label>
        <div>
          <input type="text" placeholder="Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline">
        <label>Task</label>
        <div>
          <quill-editor
            name="task"
            :options="editorOption"
            :content="editTask"
            v-model="editTask"
          />
        </div>
      </div>
      <div class="form-inline">
        <label>Client Description</label>
        <div>
          <quill-editor
            name="Client Description"
            :options="editorOption"
            :content="editClientDescription"
            v-model="editClientDescription"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Project Phase:</label>
        <div>
          <model-select
            :options="projectPhaseOptions"
            v-model="editProjectPhase"
            placeholder="Project Phase"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Notification</label>
        <div>
          <model-select
            :options="emailNotificationOptions"
            v-model="editEmailNotification"
            placeholder="Email Notification"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Anonymous</label>
        <div>
          <model-select
            :options="anonymousOptions"
            v-model="editAnonymous"
            placeholder="Anonymous"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="loading"
          @click.native="buttonClick"
          >Edit Project</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
import * as database from "@/vendor/database";
import "vue-search-select/dist/VueSearchSelect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment-timezone";
import { ModelSelect } from "vue-search-select";

export default {
  props: ["propsData", "projectPhaseOptions"],
  components: {
    spinnerButton,
    VueCtkDateTimePicker,
    ModelSelect,
  },
  data() {
    return {
      loading: false,
      data: null,
      editId: null,
      editTitle: null,
      editLocation: null,
      editTask: null,
      editClientDescription: null,
      editEngagement: null,
      editEstimatedStart: null,
      editProjectPhase: null,
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
      editEmailNotification: false,
      emailNotificationOptions: [
        {
          value: true,
          text: "True",
        },
        {
          value: false,
          text: "False",
        },
      ],
      editAnonymous: false,
      anonymousOptions: [
        {
          value: true,
          text: "True",
        },
        {
          value: false,
          text: "False",
        },
      ],
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    initData: function () {
      this.editId = this.propsData.id;
      this.data = JSON.parse(JSON.stringify(this.propsData));
      this.editTitle = this.data.title;
      this.editLocation = this.data.location;
      this.editTask = this.data.task;
      this.editClientDescription = this.data.client_description;
      this.editEngagement = this.data.engagement;
      this.editEstimatedStart = this.data.estimated_start
        ? moment(this.data.estimated_start * 1000).format("YYYY-MM-DD HH:mm")
        : null;
      this.editProjectPhase = this.data.phase;
      this.editEmailNotification = this.propsData.email_notification;
      this.editAnonymous = this.propsData.is_anon ? true : false;
    },
    buttonClick: async function () {
      const data = {
        title: this.editTitle ? this.editTitle : null,
        task: this.editTask ? this.editTask : null,
        client_description: this.editClientDescription
          ? this.editClientDescription
          : null,
        phase: this.editProjectPhase ? this.editProjectPhase : null,
        email_notification: this.editEmailNotification
          ? this.editEmailNotification
          : false,
        is_anon: this.editAnonymous ? this.editAnonymous : false,
      };
      try {
        this.loading = true;
        const result = await database.updateDocById("gigs", this.editId, data);
        if (result.ok) {
          this.$toasted.global.toast_success({
            message: "edit success",
          });
          this.$emit("closePanel");
        } else {
          this.$toasted.global.toast_error({ message: "edit error" });
        }
        this.loading = false;
      } catch {
        this.$toasted.global.toast_error({ message: "edit error" });
        this.loading = false;
      }
    },
  },
};
</script>
